import React from 'react';
import styled from 'styled-components';

import { TEXT_COLOR } from '../../theme';
import Btn from '../buttons/Btn';
import { Link } from '../common/Link';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 440px;
  height: 309px;
  margin: 0 auto;
  text-align: center;
`;

const Title = styled.h3`
  font-size: 24px;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: 0.2px;
  text-align: center;
  color: ${TEXT_COLOR};
  margin: 0 0 8px;
`;

const Content = styled.div`
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.2px;
  text-align: center;
  color: ${TEXT_COLOR};
  margin: 8px 0 24px;
`;

const Paragraph = styled.p`
  margin: 0;

  & + & {
    margin-top: 8px;
  }
`;

const ButtonWrapper = styled.div`
  padding-bottom: 5px;
`;

type ErrorScreenProps = {
  onClose: () => void;
  text: string;
  formForRecoveryPoints?: boolean;
};

const ErrorScreen = ({ onClose, text = null, formForRecoveryPoints = false }: ErrorScreenProps) => (
  <Container>
    <Title>Oups, nous avons un problème</Title>
    <Content>
      <Paragraph>
        {text ||
          'Il semblerait que les systèmes informatiques du Ministère soient temporairement hors ligne. Merci de réessayer dans quelques instants.'}
      </Paragraph>
      {text && (
        <Paragraph>
          {'Corrigez les informations dans votre '}
          <Link href="/student" target="_blank" rel="noreferrer noopener">
            espace personnel.
          </Link>
        </Paragraph>
      )}
    </Content>
    <ButtonWrapper>
      <Btn type="button" text="Fermer" onClick={onClose} />
    </ButtonWrapper>
    {!formForRecoveryPoints && (
      <ButtonWrapper>
        <Btn
          type="button"
          text="Nouvelle recherche"
          onClick={() => {
            window.location.href = '/code-de-la-route';
          }}
        />
      </ButtonWrapper>
    )}
  </Container>
);

export { ErrorScreen };
